{
  "slug": "iq-score-ranges-explained",
  "title": "شرح نطاقات علامات الذكاء",
  "description": "استكشاف نطاقات معدل الذكاء المشتركة، والمئويات التقريبية، وفترات الثقة، وحدود العلامات.",
  "summary": "إن نطاقات درجات الذكاء هي ملخصات مريحة، ولكن الحدود والعلامات تختلف من اختبار إلى آخر. وينبغي تفسير الدرجات باعتبارها تقديرات وفي سياقها.",
  "sections": [
    {
      "heading": "دليل عملي للنطاقات المشتركة",
      "paragraphs": [
        "بالنسبة لمقياس متوسطه. 100 والانحراف المعياري للنسبة المئوية 15)١( توفر هذه النطاقات توجيها عاما، وهي ليست فئات تشخيصية."
      ],
      "bullets": [
        "130 وما فوق: حوالي القمة 2%",
        "120–129: حوالي 91)أ(97المئين الثانى",
        "110–119: حوالي 75)أ( ﻻ ينطبق.90المئين الثانى",
        "90–109: النطاق المتوسط الواسع",
        "80–89: حوالي 9)أ( ﻻ ينطبق.24المئين الثانى",
        "70–79: حوالي 2)د د(8المئين الثانى",
        "أسفل 70: أقلها تقريبا 2%"
      ]
    },
    {
      "heading": "لماذا تختلف العلامات",
      "paragraphs": [
        "إن الناشرين والمؤسسات يستخدمون مصطلحات وعتبات مختلفة. والنتيجة عند نقطة ما لا تختلف بشكل ذي مغزى عن النتيجة عند نقطة أخرى، وغالباً ما تتجاوز فترات الثقة أكثر من نطاق واحد.",
        "لا ينبغي تفسير النتائج العالية أو المنخفضة من المجموع وحده، فالمهنيون ينظرون في الأداء التكيفي، والنمو، والتعليم، واللغة عندما يكون ذلك مناسباً."
      ]
    },
    {
      "heading": "اقرأ الصورة، وليس فقط الرقم",
      "paragraphs": [
        "قد يكون لشخصين يحصلان على نفس النتيجة الإجمالية نقاط قوة مختلفة. فقد يتفوق أحدهما في التفكير اللفظي بينما يتفوق الآخر في الأنماط البصرية. وقد يخفي المركب هذه الاختلافات.",
        "استخدام علامة على الإنترنت كصورة سريعة في ظل ظروف معينة، وليس علامة دائمة."
      ]
    }
  ],
  "faqs": [
    {
      "question": "ما هو معدل الذكاء المرتفع؟",
      "answer": "على نطاقات عديدة، 120 أو أعلى من المتوسط بكثير و 130 أو أعلى هو حول القمة. 2نسبة مئوية، ولكن المصطلحات تختلف."
    },
    {
      "question": "هل حدود نطاق معدل الذكاء دقيقة؟",
      "answer": "لا، لأن خطأ القياس واختلاف نظم التصنيف يجعلان الحدود تقريبية."
    }
  ],
  "related": [
    "what-is-the-average-iq",
    "what-does-an-iq-of-120-mean",
    "what-does-an-iq-of-140-mean"
  ]
}
